import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl.js"

document.addEventListener("DOMContentLoaded", () => {
    const element = document.getElementById('agendaregistrationform__date');

    if (!element) {
        return;
    }
    const unavailableDates = JSON.parse(element.dataset.disabledDate)

    flatpickr(element, {
        dateFormat: "d-m-Y",
        allowInput: true,
        disable: [
            ...unavailableDates,
            function(date) {
                // return true to disable weekends
                return (date.getDay() === 0 || date.getDay() === 6 || date.getDay() === 2 || date.getDay() === 4);
            },
            function(date) {
                // Disable past dates
                const today = new Date();
                return (date < today);
            }
        ],
        locale: Dutch,
    });
});
